import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getAllMetricsByAppID } from "../Actions/API/Metrics"
import { APIMeasurerMetric } from "../Models/API/APIMetric"
import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"

export const useMeasurerMetricList = (
    appID: string
): FetchState<APIMeasurerMetric[]> => {
    const dispatch = useDispatch()
    const metricListFetch = useAppState(
        state => state.api.metrics.measurerMetrics[appID]
    )

    useEffect(() => {
        if (metricListFetch === undefined) {
            dispatch(getAllMetricsByAppID(appID))
        }
    }, [dispatch, metricListFetch, appID])

    return metricListFetch
}
